import moment from 'moment'

// Member profiles without known date of birth are stored with the 1900-01-01 placeholder
// date in some data migrations. Member-facing apps must treat it (and absent values)
// as "no DOB on record".
export const UNKNOWN_DOB_DATE = '1900-01-01'

export const isUnknownDob = value => {
  if (!value) {
    return true
  }
  if (value instanceof Date) {
    return moment(value).format('YYYY-MM-DD') === UNKNOWN_DOB_DATE
  }
  return String(value).slice(0, 10) === UNKNOWN_DOB_DATE
}
